import REPORT from "./Report";

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/ProviderSummary/components/index.js